import {
    DependenciesPayload,
    OfferDisplayInfo,
} from '@sxm-de/dev-kits/web-sdk/types';

export async function getPackageCmsDisplayName(
    { smsPackageIds }: { smsPackageIds: string[] },
    { contentfulSdk }: DependenciesPayload,
) {
    const response = (await contentfulSdk?.getPackages({
        smsPackageIds,
        locale: '*',
        select: 'fields.package_display_name,fields.sms_package_id',
    })) as any;

    const data = smsPackageIds.reduce((items, smsPackageId) => {
        const entry = response?.items?.find(
            (item: any) => item.fields.sms_package_id['en-US'] === smsPackageId,
        );
        return {
            ...items,
            [smsPackageId]: entry
                ? Object.keys(entry.fields.package_display_name).reduce(
                      (all, locale) => {
                          return {
                              ...all,
                              [locale]: {
                                  displayName:
                                      entry.fields.package_display_name[locale],
                                  /**
                                   * TODO[ARCH]
                                   * Temporarily return empty products object until further investigation of possibly
                                   * combining both, this method and existing getOfferCmsDisplayName method.
                                   */
                                  products: {},
                              },
                          };
                      },
                      {},
                  )
                : {},
        };
    }, {} as OfferDisplayInfo);
    return data;
}
